var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.3237C10.901 10.3237 9.97423 9.94647 9.2198 9.19204C8.46537 8.43762 8.08816 7.51088 8.08816 6.41184C8.08816 5.3128 8.46537 4.38607 9.2198 3.63164C9.97423 2.87721 10.901 2.5 12 2.5C13.099 2.5 14.0258 2.87721 14.7802 3.63164C15.5346 4.38607 15.9118 5.3128 15.9118 6.41184C15.9118 7.51088 15.5346 8.43762 14.7802 9.19204C14.0258 9.94647 13.099 10.3237 12 10.3237ZM3 20.4414C3 15.4708 7.02944 11.4414 12 11.4414C16.9706 11.4414 21 15.4708 21 20.4414V21.0214C21 21.286 20.7855 21.5004 20.521 21.5004H3.479C3.21445 21.5004 3 21.286 3 21.0214V20.4414ZM14.2206 18.8868C14.1893 18.9054 14.1499 18.9054 14.1185 18.8868C12.3826 17.8601 11.1216 16.9628 10.8394 15.2697C10.817 15.1352 10.8058 14.995 10.8058 14.8492C10.8058 14.3222 10.9824 13.8821 11.3356 13.5289C11.6888 13.1757 12.1289 12.9991 12.6559 12.9991C12.9474 12.9991 13.2249 13.0608 13.4884 13.1841C13.7519 13.3075 13.979 13.4813 14.1696 13.7055C14.3602 13.4813 14.5873 13.3075 14.8508 13.1841C15.1143 13.0608 15.3918 12.9991 15.6833 12.9991C16.2103 12.9991 16.6504 13.1757 17.0036 13.5289C17.3568 13.8821 17.5334 14.3222 17.5334 14.8492C17.5334 14.995 17.5222 15.1352 17.4998 15.2697C17.2179 16.961 15.955 17.8614 14.2206 18.8868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEma);
export default __webpack_public_path__ + "static/media/ema.ef2fb4f9996736db9c8ce595f7b9f616.svg";
export { ForwardRef as ReactComponent };